import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AiRequestGuardService } from '@core/services/ai-request-guard.service';

@Injectable()
export class AiRequestGuardInterceptor implements HttpInterceptor {
  constructor(private aiRequestGuard: AiRequestGuardService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      !this.aiRequestGuard.shouldGuard(request.method, request.urlWithParams)
    ) {
      return next.handle(request);
    }

    return this.aiRequestGuard.run(
      request.method,
      request.urlWithParams,
      request.body,
      () => next.handle(request)
    );
  }
}
